export const downloadImageType = 'png';
export const maxFileSize = 10;
export const LIST_LIMIT = 20;
export const fileTypeSupport = ['application/pdf', 'image/x-eps', 'application/illustrator', 'application/postscript', 'image/jpeg', 'image/jpg', 'image/png'];
const rootElement = document.getElementById("jasani_product_builder");
const GoogleAPIKey = rootElement?.getAttribute("data-google-font-key");

export const GoogleFontApi = "https://fonts.googleapis.com/css?family=";
export const APIEndPoint = 'https://logotoolapi.jasani.ae'; // prod
export const APIVersion = '/api/';

export const apiUrls = {
    imageConvert: APIEndPoint + APIVersion + 'convert/',
    convertedImage: APIEndPoint + '/media/',
    imageColorReplace : APIEndPoint + APIVersion + 'fill-color/',
    backgroundRemove : APIEndPoint + APIVersion + 'background/',
    adjustPadding : APIEndPoint + APIVersion + 'remove-padding/',
    googleFontApi: `https://webfonts.googleapis.com/v1/webfonts?key=${GoogleAPIKey}&sort=popularity`
}


export const errorMessages = {
    SERVER_ERROR : "Something went wrong contact server team!!",
    PROJECT_SAVED : "Project Save!!!",
    UNDO_FINISH : "Do not do anything anymore, you are going far to the past, before creation, there was nothing",
    REDO_FINISH : "Do not do anything anymore, you do not know what is after the present, do not mess with the future",
    UPLOAD_FILE : "Please upload file",
    LOGO_NOT_PROPER: 'Please upload proper logo file!!',
    LOGO_FILE_GREATER: "File may not be greater than 10 MB",
    LOGO_FORMATE_ISSUE: "Please upload only this file type: jpg, jpeg, png, pdf, eps, ai format",
    OBJ_NOT_SELECTED: "Please select image or text you want to align",
    ALERT_OBJECT_SELECTION: "Please select logo or text you want to delete.",
    CONFIRMATION_MESSAGE: "Are you sure want to delete?",
    CONFIRMATION_BACK_TO_STEP_1: "If you move step 1, it will discard all the changes. Are you sure you want to switch to step 1?",
    NOTE_MESSAGE_TECHNIQUE: "Note: Only solid color logos are permitted for the selected technique.",
    CONFIRMATION_GRADIENT_MESSAGE_TECHNIQUE: "We have detected an gradient image. Are you certain you want to continue with the same logo? Only solid color logos are permitted for the selected technique.",
    MOBILE_ALERT: "For a best user experience, please use the desktop version.",
    LOGO_TEXT_LIMIT: "Only one text and logo are permitted per print area.",
    TEXT_EMPTY: "Please write text to add.",
    POSITION_EMPTY: "Action required: Branding Area cannot be empty."
}

export const Techniques = {
    "Laser Engraving": "LASER_ENGRAVING"
}
